import { RefObject, useEffect, useState } from 'react';

const useOnScreen = (refs: RefObject<HTMLElement>[], rootMargin?: string) => {
  const [visibleIndex, setVisibleIndex] = useState(-1);
  const [entries, setEntries] = useState<IntersectionObserverEntry[]>([]);
  const [visibleRefs, setVisibleRefs] = useState<number[]>([]);

  useEffect(() => {
    const observer = new IntersectionObserver((newEntries) => {
      setEntries(newEntries);
    }, rootMargin && { rootMargin });

    refs
      .filter((r) => !!r.current)
      .forEach((ref) => observer.observe(ref.current));

    return () => observer.disconnect();
  }, []);

  useEffect(() => {
    let newVisibleRefs = [...visibleRefs];

    const invisibleEntries = entries.filter((entry) => !entry.isIntersecting);
    for (const invisibleEntry of invisibleEntries) {
      const invisibleRefIndex = refs.findIndex(
        (ref) => ref.current.className === invisibleEntry.target.className
      );
      newVisibleRefs = newVisibleRefs.filter((i) => i !== invisibleRefIndex);
    }

    const visibleEntries = entries.filter((entry) => entry.isIntersecting);
    for (const visibleEntry of visibleEntries) {
      const visibleRefIndex = refs.findIndex(
        (ref) => ref.current.className === visibleEntry.target.className
      );
      if (!newVisibleRefs.includes(visibleRefIndex)) {
        newVisibleRefs = [visibleRefIndex, ...newVisibleRefs];
      }
    }
    setVisibleIndex(
      newVisibleRefs.length > 0 ? Math.min(...newVisibleRefs) : -1
    );
    setVisibleRefs(newVisibleRefs);
  }, [entries]);

  return visibleIndex;
};

export default useOnScreen;
